import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { dsApi, dsDtos } from '@vectronic/openApi-admin';
import { BehaviorSubject, shareReplay, switchMap, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AnimalSpeciesService {
  private animalSpeciesApi = inject(dsApi.AnimalSpecies);

  private refresh$ = new BehaviorSubject<void>(null);
  animalSpecies$ = this.refresh$.pipe(
    switchMap(() => this.animalSpeciesApi.get()),
    shareReplay(1),
  );
  animalSpecies = toSignal(this.animalSpecies$);

  addAnimalSpecies(dto: dsDtos.AnimalSpeciesInput) {
    return this.animalSpeciesApi.add(dto).pipe(tap(() => this.refresh$.next(null)));
  }
  getAnimalSpeciesById(id: string) {
    return this.animalSpecies().find((animalSpecie) => animalSpecie.id === id);
  }

  delete(id: string) {
    return this.animalSpeciesApi._delete(id).pipe(tap(() => this.refresh$.next(null)));
  }

  edit(dto: dsDtos.AnimalSpeciesInput, id: string) {
    return this.animalSpeciesApi.edit(id, dto).pipe(tap(() => this.refresh$.next(null)));
  }
}
